﻿/**
 * decode access token for GTM
 * @param {String} jwt string value of jwt
 * @param {Boolean} pushToDatalayer push to dataLayer before returning object
 */

export function gaDecodeTokenAction(jwt, pushToDataLayer = true) {
  return (_dispatch) => gaDecodeToken(jwt, pushToDataLayer)
}

const gaDecodeToken = async (jwt, pushToDatalayer = true) => {
  /**
   * sha256 encrypt
   * @param {String} message string value to be encrypted
   * @returns
   */
  const sha256 = async (message) => {
    // hash the message
    const hashBuffer = await crypto.subtle.digest(
      'SHA-256',
      new TextEncoder().encode(message),
    )

    // convert bytes to hex string
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('')
  }
  /**
   *
   * @param {String} str possible string value to be checked
   * @returns {Boolean}
   */
  const isStringDefined = (str) =>
    Object.prototype.toString.call(str).slice(8, -1) === 'String' && str !== ''
  if (!isStringDefined(jwt)) {
    return (window.dataLayer = window.dataLayer || []).push({
      event: 'b2cloaded',
      companyID: null,
      HEM: null,
      loginID: null,
      catRecId: null,
      affClass: null,
      affCode: null,
      affiliationOrgCode: null,
      affiliationOrgName: null,
      B2CdealerCode: null,
      topLvlOrgCode: null,
      B2CObjectID: null,
      B2CUserType: null,
    })
  }
  const claims = jwt
    .split('.', 2)
    .reduce((obj, fragment) => ({ ...JSON.parse(atob(fragment)), ...obj }), {})

  const data = Object.entries({
    event: 'b2cloaded',
    companyID: String(claims.ucid).toLowerCase(), // Customer Company ID -UCID
    HEM: await sha256(String(claims.email_address).toLowerCase()), // hash this
    loginID: await sha256(String(claims.catloginid).toLowerCase()), // The user's CWSID
    catRecId: String(claims.catrecid).toLowerCase(), // Cat RecID
    affClass: String(claims.catafltnclass).toLowerCase(), // Affiliation Class
    affCode: String(claims.catafltncode).toLowerCase(), // Affiliation Code
    affiliationOrgCode: String(claims.catafltnorgcode).toLowerCase(),
    affiliationOrgName: String(claims.company).toLowerCase(),
    B2CdealerCode: String(claims.catafltnorgcode).toLowerCase(), //Affiliation Org Code
    topLvlOrgCode: String(claims.cattoplevelorgcode).toLowerCase(), // Top Level Org Code
    B2CObjectID: String(claims.aud).toLowerCase(), // B2C Object ID (if this can be used as match point to B2C records for reporting and stays consistent per contact over time.
    B2CUserType: String(claims.catafltnclass).toLowerCase(), // B2C User Type
  }).reduce(
    (obj, [key, value]) => ({
      ...obj,
      [key]: value === 'undefined' ? null : value,
    }),
    {},
  )
  if (pushToDatalayer) {
    ;(window.dataLayer = window.dataLayer || []).push(data)
  }
  return data
}
